import { Badge, Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import { MetadataFilters } from "./types";
import { formatMetadataFilterLabel } from "./utils";

interface MetadataFiltersSummaryProps {
  filters: MetadataFilters;
}

/**
 * Friendly, human-readable rendering of the metadata filters an agent answer
 * applied. The raw ``[metadata_filters: {...}]`` block is stripped from the
 * message prose (see ``stripMetadataFiltersBlock``); this shows the same
 * information as a compact row of "name=value" badges so the user can see
 * what the results were narrowed by. Renders nothing when there are no
 * filters.
 */
const MetadataFiltersSummary: React.FC<MetadataFiltersSummaryProps> = ({
  filters,
}) => {
  const entries = Object.entries(filters);
  if (entries.length === 0) {
    return null;
  }

  return (
    <div data-testid="metadata-filters-summary">
      <SpaceBetween direction="horizontal" size="xs">
        <Box
          variant="strong"
          fontSize="body-s"
          color="text-body-secondary"
          padding={{ top: "xxs" }}
        >
          Filters applied:
        </Box>
        {entries.map(([key, value]) => (
          <Badge key={key} color="blue">
            {formatMetadataFilterLabel(key)}={value}
          </Badge>
        ))}
      </SpaceBetween>
    </div>
  );
};

export default MetadataFiltersSummary;
